export default async ctx => {
  if (ctx.env.previewMode && process.client) {
    await ctx.store.dispatch('nuxtServerInit', ctx)
  }
}
